export const enum ProductsLayout {
  CAROUSEL = 'Carousel',
  GRID = 'Grid',
  DEFAULT = 'Default for current module'
}
